module.exports = __webpack_public_path__ + "static/media/startIconShoppingList.66d2fab9.svg";